module.exports = __webpack_public_path__ + "img/france-flag.702c6ce0.svg";